<template>
  <transition name="back-to-top-fade">
    <div class="vue-back-to-top" :style="`bottom:${this.bottom};right:${this.right};`" v-show="visible" @click="backToTop">
      <slot>
        <div class="default">
          <span class="icon is-medium">
            <i class="fas fa-angle-double-up"></i><br>
          </span>
        </div>
      </slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BackToTop',
  props: {
    text: {
      type: String,
      default: 'TOP'
    },
    visibleOffset: {
      type: [String, Number],
      default: 600
    },
    right: {
      type: String,
      default: '30px',
    },
    bottom: {
      type: String,
      default: '40px',
    },
  },
  data () {
    return {
      visible: false
    }
  },
  /**
   * Catch window scroll event
   * @return {void}
   */
  created () {
    let catchScroll = () => {
      this.visible = (window.pageYOffset > parseInt(this.visibleOffset))
    }
    window.smoothscroll = () => {
      let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll)
        window.scrollTo(0, Math.floor(currentScroll - (currentScroll / 5)))
      }
    }
    window.onscroll = catchScroll
  },
  methods: {
    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop () {
      window.smoothscroll()
    }
  }
}
</script>
<style scoped>
  .back-to-top-fade-enter-active, .back-to-top-fade-leave-active {
    transition: opacity .7s;
  }
  .back-to-top-fade-enter, .back-to-top-fade-leave-to{
    opacity: 0;
  }

  .vue-back-to-top{
    position: fixed;
    z-index: 1000;
    cursor:pointer;
  }

  .vue-back-to-top .default {
    text-align: center;
    border-radius: 5px;
    background-color: #939393;
    opacity: 0.5;
    width: 35px;
    height: 35px;
    display: block;
    left: 0px;
    top: 0px;
  }

  .vue-back-to-top .default span{
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/backtotop.vue